// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      slug: string,
      description: anyOf(string, nullOrUndefined),
      updated_at: number,
      created_at: number,
      status: enumOf("draft", "published", "unpublished", "archived"),
      base_url: string,
      full_url: string,
      html_empty: boolean,
    })
  ),
});
